import DailyBranchCollection from './DailyBranchCollection'
// import BookingReport from './BookingReport'
import BookingReport from './BookingReports/Index'
import DispatchReport from './DispatchReport'
import DeliveryReport from './DeliveryReport/DeliveryReport'
import BranchTransferReport from './BranchTransferReport'
import BranchReceiveReport from './BranchReceiveReport'
import AmountCreditReport from './onAccountCreditReport/index'
import AnalysisReport from './analysisReport/AnalysisReport'
import NonMovmentReport from './NonMovmentReport'
import QuickViewReport from './quickViewReport/index'
import EwayBookingReport from './EwayBookingReport/EwayBookingReport'
import PartyBookingReport from './partyBookingReport/PartyBookingReport'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import BkngDelvryTrackingReport from './BkngDelvryTrackingReport/BkngDelvryTrackingReport'
import ReceivedReport from "./receivedReport/ReceivedReport"
import GoodBalance from './GoodBalance/Index'
import LrCancelPenalityReport from './LrCancelPenalityReport'
import CargoUnloadingReport from './CargoUnloadingReport/CargoUnloadingReport'
import RefundReport from './RefundReport/Index'
import RechargePenaltyReport from './RechargePenaltyReport'
import UserWithTransRightReport from './UserWithTransRightReport'
import PartyTargetVsAchivementReport from './PartyTargetVsAchivementReport'
import LuggageModificationReport from './luggageModificationReport/LuggageModificationReport'
import BranchStockReport from './BranchStockReport/BranchStockReport'
import ToPayDestinationReport from './ToPayDestinationReport/ToPayDestinationReport'
import ReceiptRegisterReport from './ReceiptRegisterReport/ReceiptRegisterReport'
import FranchiseOutstandingReport from './FranchiseOutstandingReport/FranchiseOutstandingReport'
import DispatchRegister from './DispatchRegister'
import TopayStatenentReport from './TopayStatementReport/TopayStatenentReport'
import UserWiseCollectionWithDeliveryExpense from './UserWiseCollectionWithDeliveryExpense/UserWiseCollectionWithDeliveryExpense'
import RechargeHistoryReport from './RechargeHistoryReport/RechargeHistoryReport'
import BranchBalanceReport from './brnachBalanceReport/BranchBalanceReport'
import BranchwiseCollectionNew from './BranchwiseCollectionNew'
import UserWiseCollectionNew from './userWiseCollReport/UserWiseCollectionNew'
import ReceiveReportNew from './receivedReport/ReceiveReportNew'
import BranchStockReportNew from './BranchStockReport/BranchStockReportNew'
export const Reports = () => {
  const [searchParams] = useSearchParams()
  const [reportNumber, setReportNumber] = useState(Number(searchParams.get('id')))
  useEffect(() => {
    setReportNumber(Number(searchParams.get('id')))
  }, [searchParams])
  let reportType
  switch (reportNumber) {
    case 1: {
      reportType = <BranchwiseCollectionNew />
      break
    }
    case 2: {
      reportType = <BookingReport />
      break
    }
    case 3: {
      reportType = <DispatchReport />
      break
    }
    case 4: {
      reportType = <ReceiveReportNew />
      break
    }
    case 5: {
      reportType = <DeliveryReport />
      break
    }
    case 6: {
      reportType = <BranchTransferReport />
      break
    }
    case 7: {
      reportType = <BranchReceiveReport />
      break
    }
    case 8: {
      reportType = <AmountCreditReport />
      break
    }
    case 9: {
      reportType = <AnalysisReport />
      break
    }
    case 10: {
      reportType = <NonMovmentReport />
      break
    }
    case 11: {
      reportType = <QuickViewReport />
      break
    }
    case 12: {
      reportType = <EwayBookingReport />
      break
    }
    case 13: {
      reportType = <PartyBookingReport />
      break
    }
    case 14: {
      reportType = <UserWiseCollectionNew />
      break
    }
    case 15: {
      reportType = <GoodBalance />
      break
    }
    case 16: {
      reportType = <BkngDelvryTrackingReport />
      break
    }
    case 17: {
      reportType = <CargoUnloadingReport />
      break
    }
    case 18: {
      reportType = <LrCancelPenalityReport />
      break
    }
    case 19: {
      reportType = <RefundReport />
      break
    }
    case 20: {
      reportType = <UserWithTransRightReport />
      break
    }
    case 21: {
      reportType = <PartyTargetVsAchivementReport />
      break
    }
    case 22: {
      reportType = <RechargePenaltyReport />
      break
    }
    case 23: {
      reportType = <BranchStockReportNew />
      break
    }
    case 24: {
      reportType = <ToPayDestinationReport />
      break
    }
    case 51: {
      reportType = <LuggageModificationReport />
      break
    }
    case 26: {
      reportType = <ReceiptRegisterReport />
      break
    }
    case 25: {
      reportType = <FranchiseOutstandingReport/>
      break
    }
    case 100: {
      reportType = <DispatchRegister />
      break
    }
    case 30: {
      reportType = <TopayStatenentReport />
      break
    }
    case 31: {
      reportType = <UserWiseCollectionWithDeliveryExpense />
      break
    }
    case 32: {
      reportType = <BranchBalanceReport />
      break
    }
    case 33: {
      reportType = <RechargeHistoryReport />
      break
    }
    default:
      reportType = <AnalysisReport />
      break
  }
  return reportType
}
